<template>
  <span
    class="zoox-component zoox-country-flag flag-icon"
    :class="countryFlag"
    :style="flagStyle"
  ></span>
</template>

<script>
/**
 * @displayName Country Flag
 */
export default {
  name: 'ZCountryFlag',
  props: {
    country: {
      type: String,
      required: true,
      default: 'br',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    countryFlag() {
      const countryClass = `fi fi-${this.country.toLowerCase()}`

      return {
        [countryClass]: true,
        'is-rounded': this.rounded,
      }
    },
    flagStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-country-flag {
  &.is-rounded {
    background-size: cover;
    border-radius: 50%;
  }
}
</style>
